<template>
    <div
        v-if="show"
        class="fixed inset-0 flex justify-center items-center bg-[rgba(30,41,59,0.50)] z-50"
    >
        <div
            class="flex flex-col justify-center items-center gap-8 w-[720px] p-6 bg-white rounded-md shadow-lg"
        >
            <div class="flex items-center justify-between w-full">
                <h2 class="text-xl font-normal text-slate-800">
                    Leave your voicemail
                </h2>
                <button @click="close" class="text-slate-800 text-2xl">
                    &times;
                </button>
            </div>
            <div class="flex flex-col items-center gap-2">
                <iframe
                    src="https://www.speakpipe.com/widget/inline/fwszobbicdenfeyylltoo5ya424f1lhp"
                    allow="microphone"
                    width="100%"
                    height="200"
                    frameborder="0"
                ></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/ui/icon/icon.vue';

export default {
    props: {
        show: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
    },
};
</script>
